import ILessonResponse from "../models/lessonWithSingleModeSegments/ILessonResponse";

export function createLessonWithSingleModeSegmentsResponseFromJson(json: object = {}) : ILessonResponse{
  // In the future, perhaps we can use zod to validate the response DTO, instead of just asserting its type
  return json as ILessonResponse;
}
